import useNameValidator from './useNameValidator';
import { InputWithErrorDescription } from 'components/base/Input';
import { Stack } from '@mui/material';
import { StyledSectionTitle } from './CreateEditProjectModal.style';

const NameSelector = ({ curProjectName, projectName, setCurProjectName }) => {
  const nameValidator = useNameValidator(projectName, curProjectName);

  const onProjectNameChange = e => {
    if (!nameValidator.started) {
      nameValidator.startValidation();
    }
    setCurProjectName(e);
  };

  return (
    <Stack spacing={1} marginBottom={3} sx={{ width: '70%' }}>
      <StyledSectionTitle className='mandatory'>
        Project Name
      </StyledSectionTitle>
      <InputWithErrorDescription
        dataCy='projectNameInput'
        style={{ padding: '0.7rem' }}
        width='100%'
        flex='1'
        value={curProjectName}
        onChange={onProjectNameChange}
        disabled={false}
        onBlur={nameValidator.startValidation}
        isError={!nameValidator.isValid && nameValidator.started}
        errorDescription={nameValidator.description}
      />
    </Stack>
  );
};

export default NameSelector;
